import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a558222"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center h-100" }
const _hoisted_2 = {
  class: "mxa-header-account-circle",
  "data-test": "username_one"
}
const _hoisted_3 = ["title"]

import { useStore } from '@/store'


import { defineComponent, computed } from 'vue'

const __default__ = defineComponent({
  inheritAttrs: false,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TheHeaderAcount',
  setup(__props) {

const store = useStore()
// アカウント表示名
const usernameDisp = computed(() => store.getters.dispUsername)
// アカウント表示名の最初の文字
const usernameDispFirst = computed(() => store.getters.dispUsernameFirst)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(usernameDispFirst)), 1),
    _createElementVNode("div", {
      class: "mxa-header-account-text",
      "data-test": "username",
      title: _unref(usernameDisp)
    }, _toDisplayString(_unref(usernameDisp)), 9, _hoisted_3)
  ]))
}
}

})